// extracted by mini-css-extract-plugin
export var discard = "_4o-3";
export var muiTooltipTooltip = "_4o-5";
export var notificationBar = "_4o-2";
export var saveButtonHoverSlotWrapper = "_4o-4";
export var show = "_4o-1";
export var spacer = "_4o-0";